export function encodePassphrase(passphrase: string) {
    return encodeURIComponent(passphrase);
}

export function decodePassphrase(base64String: string) {
    return decodeURIComponent(base64String);
}

export function randomString(length: number): string {
    const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
    return Array.from(crypto.getRandomValues(new Uint32Array(length)), (value) =>
        characters.charAt(value % characters.length)
    ).join('');
}

export function isLowPowerDevice() {
    return navigator.hardwareConcurrency < 6;
}
